import React from 'react';
import AsyncSelect from 'react-select/async';
import { SelectOption } from 'utility/types';
import makeAnimated from "react-select/animated";
import { GroupBase, InputActionMeta, OptionsOrGroups } from 'react-select';

interface AsyncSelectInterface {
  selectOptions: SelectOption[];
  promiseOptions: (inputValue: string, callback: (options: OptionsOrGroups<{ label: string; value: string; }, GroupBase<{ label: string; value: string; }>>) => void) => void;
  formatOptionLabel: ({ value, label }: SelectOption) => React.JSX.Element;
  placeholder: string;
  inputValue: string,
  selectedValue: { label: string, value: string }
  onInputChange(newValue: string, action: InputActionMeta): void;
  variant?: "default" | "hero";
}

const AsyncSelectComponent = ({ selectOptions, promiseOptions, formatOptionLabel, placeholder, inputValue, selectedValue, onInputChange, variant = "default" }: AsyncSelectInterface) => {
  const FIXED_HEIGHT = "23px !important";
  const isHero = variant === "hero";
  const HERO_HEIGHT = "24px !important";
  const colourStyles = {
    control: (styles: any) => ({ ...styles,
      backgroundColor: 'red',
      fontSize: "12px",
      height: FIXED_HEIGHT,
      minHeight: "auto",
      flex: 1,
      border: "none",
      background: "#E9E9E9",
      padding: "4px 9px",
      borderRadius: "4px",
      postion: "relative",
      width: "100%",
      minWidth: "auto",
    }),
    container: (styles: any) => ({
      ...styles,
      height: FIXED_HEIGHT,
      minHeight: "auto",
    }),
    input: (styles: any) =>({
      ...styles,
      height: FIXED_HEIGHT,
      minHeight: "auto",
    }),
    placeholder: (styles: any) => ({
      ...styles,
      height: FIXED_HEIGHT,
      minHeight: "auto",
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      height: FIXED_HEIGHT,
      minHeight: "auto",
      top: "-5px",
      left: "-9px"
    }),
    noOptionsMessage: (styles: any) => ({
      ...styles,
      fontSize: "12px"
    }),
    menuList: (styles: any) => ({
      ...styles,
      position: "relative",
      zIndex: 20
    }),
  };

  const heroStyles = {
    control: (styles: any) => ({
      ...styles,
      fontSize: "14px",
      height: HERO_HEIGHT,
      minHeight: "auto",
      flex: 1,
      border: "none",
      boxShadow: "none",
      background: "transparent",
      padding: 0,
      width: "100%",
      minWidth: "auto",
      cursor: "text",
    }),
    container: (styles: any) => ({
      ...styles,
      height: HERO_HEIGHT,
      minHeight: "auto",
      width: "100%",
    }),
    input: (styles: any) => ({
      ...styles,
      height: HERO_HEIGHT,
      minHeight: "auto",
      margin: 0,
      padding: 0,
      color: "#656363",
    }),
    placeholder: (styles: any) => ({
      ...styles,
      height: HERO_HEIGHT,
      minHeight: "auto",
      fontSize: "14px",
      color: "#656363",
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      height: HERO_HEIGHT,
      minHeight: "auto",
      padding: 0,
    }),
    noOptionsMessage: (styles: any) => ({
      ...styles,
      fontSize: "13px",
    }),
    menu: (styles: any) => ({
      ...styles,
      marginTop: 8,
      borderRadius: 4,
      overflow: "hidden",
      border: "1px solid #CFCFCF",
      width: "calc(100% + 32px)",
      left: -32,
    }),
    menuList: (styles: any) => ({
      ...styles,
      position: "relative",
      zIndex: 20,
    }),
  };

  return  <AsyncSelect
      defaultOptions={selectOptions}
      cacheOptions
      loadOptions={promiseOptions}
      formatOptionLabel={formatOptionLabel}
      components={{ ...makeAnimated, IndicatorSeparator: null, DropdownIndicator:() => null }}
      controlShouldRenderValue={false}
      tabSelectsValue={false}
      isClearable={false}
      hideSelectedOptions={false}
      backspaceRemovesValue={false}
      placeholder={placeholder}
      styles={isHero ? heroStyles : colourStyles}
      inputValue={inputValue}
      value={selectedValue}
      onInputChange={onInputChange}
      openMenuOnFocus={false}
      menuIsOpen={inputValue.trim().length > 0 ? undefined : false}
      noOptionsMessage={() => "No documentation found"}
      menuPosition="fixed"
      closeMenuOnSelect={false}
      blurInputOnSelect={true}
    ></AsyncSelect>
}

export default AsyncSelectComponent;
